import classnames from 'classnames/bind';
import { DATE_FORMAT_WITH_TIME_NO_SECOND, format } from 'date-util';
import { FC } from 'react';
import { ApproverInformationProps } from '../../types';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const ApproverInformation: FC<ApproverInformationProps> = ({
  approver,
}) => {
  return (
    <div className={cx('container')}>
      <span className={cx('name')}>{approver?.approver_display_name}</span>
      <div className={cx('status-container')}>
        <span>{approver?.approve_type}</span>
        <span>
          {format(approver?.approve_time, DATE_FORMAT_WITH_TIME_NO_SECOND)}
        </span>
      </div>
    </div>
  );
};
